import { render, staticRenderFns } from "./comMagnifier.vue?vue&type=template&id=6479d0ec&scoped=true&"
import script from "./comMagnifier.vue?vue&type=script&lang=js&"
export * from "./comMagnifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479d0ec",
  null
  
)

export default component.exports